import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import _get from 'lodash/get';
import Textarea from '../../../../components/Textarea';
import UploadsBlock from './UploadsBlock';
import GlobalContext from '../../../../utils/GlobalContext';

const TestResultsBlock = ({
  hideAnalyse = false,
  handleChange,
  textStyle,
  textColor,
  linkColor,
  isEditable = true,
}) => {
  const { locales } = useContext(GlobalContext);

  const {
    testDocument: { collection, uploadingResult },
    testing: { test },
  } = useSelector((state) => state);

  const resultCollection = collection.filter(
    (e) => e.documentType === 'result',
  );
  const isHomepage = test.test === 'homepage';

  return (
    <div className="test-card__section">
      <div className="left">
        {((isHomepage && !hideAnalyse) || !isHomepage) && (
          <div className="block">
            <div
              className={`title ${textStyle} custom-font-body`}
              style={{ color: textColor }}
            >
              {locales.testing.testCard.testResults}
            </div>
            <div
              className={classNames('is-full-width', { content: isHomepage })}
            >
              {_get(test, 'analyse.analyseResultsClickedAt') ? (
                <div
                  className={classNames({
                    'content is-full-width': !isHomepage,
                  })}
                >
                  {isEditable ? (
                    <Textarea
                      onChange={handleChange}
                      delay={700}
                      value={test.analyse.resultsAndLearning || ''}
                      name="analyse.resultsAndLearning"
                      className={`bmc-form-textarea ${textStyle} custom-font-body`}
                    />
                  ) : (
                    <div
                      className={`text ${textStyle} custom-font-body`}
                      style={{ color: textColor }}
                    >
                      {test.analyse.resultsAndLearning || ''}
                    </div>
                  )}
                </div>
              ) : (
                <div className={classNames({ content: !isHomepage })}>
                  <div
                    className={`text ${textStyle} custom-font-body`}
                    style={{ color: textColor }}
                  >
                    {locales.testing.testResultsNoAnalysisMessage}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {!isHomepage && (
        <UploadsBlock
          collectionType={resultCollection}
          uploadsType="result"
          uploadingStatus={uploadingResult}
          textStyle={textStyle}
          textColor={textColor}
          linkColor={linkColor}
          isEditable={isEditable}
        />
      )}
    </div>
  );
};

export default TestResultsBlock;
